import { readFragment } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

import {
  PostMediaAsset,
  PostMediaAsset_Asset,
} from '../PostCard/PostMedia/PostMediaAsset'

import styles from './ContentItemMedia.module.css'

import type { JSX } from 'react'

type ContentItemMediaProps = {
  assets: FragmentOf<typeof PostMediaAsset_Asset>[]
}

/**
 * Display-only media row for a channel-less draft. Unlike PostMediaRowPreview
 * the thumbnails are not individually interactive and need no PostCardContext.
 * Each PostMediaAsset fills its parent, so it is wrapped in a fixed square box
 * (see the CSS module) to cap the thumbnail size.
 */
export const ContentItemMedia = ({
  assets,
}: ContentItemMediaProps): JSX.Element | null => {
  if (!assets.length) {
    return null
  }

  const readAssets = readFragment(PostMediaAsset_Asset, assets)

  return (
    <div className={styles.row}>
      {assets.map((asset, index) => (
        // PostMediaAsset fills its parent, so the fixed-size box lives here.
        <div key={readAssets[index].source} className={styles.item}>
          <PostMediaAsset asset={asset} />
        </div>
      ))}
    </div>
  )
}
